import { css } from '@emotion/css';
import { Table } from '@mantine/core';
import { flexRender, type Row } from '@tanstack/react-table';
import type { LightThread } from 'modules/Mails/hooks/use-load-mails';
import { memo } from 'react';

type MailRowProps = {
  row: Row<LightThread>;
  isSelected: boolean;
  onClick: (e: React.MouseEvent) => void;
  onAuxClick: (e: React.MouseEvent) => void;
};

export const MailRow = memo(
  ({ row, isSelected, onClick, onAuxClick }: MailRowProps) => {
    return (
      <Table.Tr
        bg={isSelected ? 'blue.1' : !row.original.mailDetail.read ? 'purple.1' : undefined}
        style={{ cursor: 'pointer' }}
        onClick={onClick}
        onAuxClick={onAuxClick}
        className={hoverUnreadRow(row.original.mailDetail.read)}
      >
        {row.getVisibleCells().map(cell => (
          <Table.Td key={cell.id} data-col={cell.column.id}>
            {flexRender(cell.column.columnDef.cell, cell.getContext())}
          </Table.Td>
        ))}
      </Table.Tr>
    );
  },
  (prev, next) =>
    prev.row.id === next.row.id &&
    prev.isSelected === next.isSelected &&
    prev.row.original.mailDetail.read === next.row.original.mailDetail.read &&
    prev.row.original.isProcessed === next.row.original.isProcessed &&
    prev.row.original.hasDraft === next.row.original.hasDraft &&
    prev.row.original.replyCount === next.row.original.replyCount &&
    prev.row.original.debtor?.id === next.row.original.debtor?.id &&
    prev.row.original.accountManager?.id === next.row.original.accountManager?.id,
);

const hoverUnreadRow = (isRead: boolean) => css`
    &:hover {
      background-color: ${
        isRead ? 'var(--mantine-color-purple-0)' : 'var(--mantine-color-purple-1)'
      } !important;
    }
  `;
